module.exports = __webpack_public_path__ + "static/media/checkoutTransactions.4c58fe2d.svg";